// extracted by mini-css-extract-plugin
export default {"navButton":"CarouselArrowButton_navButton__TlX1A"};